import * as React from 'react'
import { ScrollView, View } from 'react-native'
import styled from '@theme/styled-components'

import Button from '@components/button/Button'
import Animators from '@components/root/Animators'
import Root from '@components/root/Root'

import Info from '../form/Info'
import scheme from '../scheme'

import useI18n from '@i18n/useI18n'

// Mobile render with only form
const FormLayout = ({ title, form, onForm, onSceneChange, onBack }: SignatureLayoutProps) => {
  const i18n = useI18n()

  const [valid, setValid] = React.useState(false)

  React.useEffect(() => {
    scheme.info
      .validate(form)
      .then(() => setValid(true))
      .catch(() => setValid(false))
  }, [form])

  return (
    <Root fixed header={title} onLeft={onBack}>
      <MainContainer>
        <Animators>
          <Info form={form} onForm={onForm} />
        </Animators>
      </MainContainer>

      <Buttons>
        <ButtonContainer>
          <Button
            label={i18n.t('common.validate')}
            status={valid ? 'active' : 'disabled'}
            onClick={() => onSceneChange('ORGANIZER_SIGNATURE')}
          />
        </ButtonContainer>
      </Buttons>
    </Root>
  )
}

export default FormLayout

const MainContainer = styled(ScrollView)`
  flex: 1;
  flex-direction: column;
  padding: 24px 16px;
  background-color: ${(props) => props.theme.colors.backgroundSecondary};
`

const Buttons = styled(View)`
  background-color: ${(props) => props.theme.colors.background};
`

const ButtonContainer = styled(View)`
  margin: 12px;
`
